import { NavLink } from 'react-router';
import { INDEPENDENCE_NOTICE, SITE_TAGLINE } from '../../../shared/seo/pages.ts';
import { BOTTOM_NAV } from '../../app/navigation.ts';
import { Logo } from './Logo.tsx';

/** Navigation basse mobile (< 768 px), au-dessus de la zone de sécurité iOS. */
export function BottomNavigation() {
  return (
    <nav className="bottom-nav" aria-label="Navigation principale (mobile)">
      <ul>
        {BOTTOM_NAV.map(({ to, label, icon: Icon, end }) => (
          <li key={to}>
            <NavLink to={to} end={end}>
              <Icon size={22} aria-hidden="true" />
              <span>{label}</span>
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}

export function AppFooter() {
  return (
    <footer className="app-footer">
      <div className="container app-footer__inner">
        <div className="app-footer__brand">
          <Logo />
          <p>{SITE_TAGLINE}</p>
        </div>
        <nav aria-label="Pied de page">
          <ul className="app-footer__links">
            <li>
              <NavLink to="/a-propos">À propos</NavLink>
            </li>
            <li>
              <a href="/a-propos#about-sources">Sources des données</a>
            </li>
            <li>
              <NavLink to="/mentions-legales">Mentions légales</NavLink>
            </li>
            <li>
              <NavLink to="/confidentialite">Confidentialité</NavLink>
            </li>
            <li>
              <NavLink to="/cgu">CGU</NavLink>
            </li>
          </ul>
        </nav>
        <p className="app-footer__notice">
          Une initiative indépendante pour les habitants d’Ermont.
          <span>{INDEPENDENCE_NOTICE}</span>
        </p>
      </div>
    </footer>
  );
}
